/**
 * Created with IntelliJ IDEA.
 * User: elanh
 * Date: 6/5/13
 * Time: 1:40 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var $ = require("jquery");
    var _ = require("underscore");
    var Backbone = require("backbone");
    var Marionette = require("marionette");
    var template = require('ui/image-picker/templates/imagePicker.tmpl');

    var SELECTED_CLASS = "selected";

    require("ui.plugins/jquery.ba-outside-events");

    var ImagePickerView = Marionette.ItemView.extend({
        template : template,
        className : "image-picker",
        events : {
            "click .image-picker-button" : "toggleImagePicker",
            "click .image-picker-preview" : "toggleImagePicker",
            "click li.image-option" : "handleImageSelected",
            "clickoutside":"closeImagePicker"
        },
        ui : {
            button : ".image-picker-button",
            thumbPreview : ".image-picker-preview",
            picker : ".image-picker-control",
            optionList : ".image-picker-options",
            options : "li.image-option"
        },
        images : [],
        initialize : function (options) {
            this.images = options.images;
            //create a plain model with the list of images so that template engine can loop over the list
            this.model = new Backbone.Model({images : this.images});
            this.permutation = options.permutation || ImagePickerView.PERMUTATION.A;
        },
        onRender : function () {
            if (this.images.length > 0) {
                //initialize with the correct selected image and set the button with the selected thumb
                var initImgId = this.$el.data("img-id");
                //set selected image only if there is an image in this.images which has an id like initImgId
                if (_.any(this.images, {id: initImgId})) {
                    this.setSelectedImage(initImgId);
                    this.setPreviewImage(initImgId);
                }
                this._setPermutationClass();
            }
        },
        _setPermutationClass : function () {
            this.$el.addClass(this._getClassByPermutation());
        },
        _getClassByPermutation : function () {
            var cssClass = "image-picker-perm-" + this.permutation;
            return cssClass;
        },
        setSelectedImage : function (id) {
            //clear current selection
            this.clearSelection();
            //using the id, set the selected el
            var selectedOption = this.ui.optionList.find("[data-id=\"" + id + "\"]");
            selectedOption.addClass(SELECTED_CLASS);
        },
        getSelectedImage : function () {
            //get the id of the selected el
            var selected = this.ui.options.find(SELECTED_CLASS);
            var imageId = selected.data("id");
            return imageId;
        },
        setPreviewImage : function (id) {
            var selected = _.find(this.images, {id : id});
            this.ui.thumbPreview.attr("src", selected.thumbUrl);
        },
        clearSelection : function () {
            //remove the selection from all options
            this.ui.options.removeClass(SELECTED_CLASS);
        },
        handleImageSelected : function (event) {
            var selectedEl = $(event.currentTarget);
            var imageId = selectedEl.data("id");
            //set selected class on selected el and remove selected class from others
            this.setSelectedImage(imageId);
            //set preview div image with selection
            this.setPreviewImage(imageId);
            //trigger selection change with id
            this.triggerImageSelectionChange(imageId);
        },
        triggerImageSelectionChange : function (id) {
            this.trigger("imagePicker:change", id);
        },

        openImagePicker : function () {
            this.ui.picker.show();
        },
        closeImagePicker : function () {
            this.ui.picker.hide();
        },
        toggleImagePicker : function () {
            if (this.ui.picker.is(":visible")) {
                this.closeImagePicker();
            } else {
                this.openImagePicker();
            }
        },
        onClose : function () {
            this.model = null;
        }

    });

    /**
     * Public static eNum of the optional permutation
     */
    ImagePickerView.PERMUTATION = {
        A : 1
    };

    return ImagePickerView;
});